import _ from 'lodash';

import SwooshableVideo from './swooshable-video';
import isUserSignedIn from '../is-user-signed-in';
import {
  recordWistiaPlayStartStatistic,
  recordWistiaPlayFinishedStatistic,
} from '../../services/statistics-service';
import getWistiaVideoHandle from '../get-wistia-video-handle';

export default class SwooshableWistiaVideo extends SwooshableVideo {
  constructor(iframe) {
    super(iframe);

    const $iframe = $(iframe);
    const wireId = $iframe.parents('article.wire').data().id;

    this.isPlaying = false;

    const videoId = $iframe.attr('id').match(/wistia_(.*)/)[1];

    getWistiaVideoHandle(videoId, videoHandle => {
      videoHandle.bind('play', () => {
        if (!isUserSignedIn() && !_.startsWith(window.location.pathname, '/wires/')) {
          videoHandle.pause();
          window.location = '/sign_up';
          return;
        }

        this.isPlaying = true;
        recordWistiaPlayStartStatistic(wireId);
      });

      videoHandle.bind('pause', () => (this.isPlaying = false));
      videoHandle.bind('end', () => {
        this.isPlaying = false;
        recordWistiaPlayFinishedStatistic(wireId);
      });
    });
  }

  get playing() {
    return this.isPlaying;
  }
}
